module.exports = __webpack_public_path__ + "img/ingredients.260ec6e5.png";